import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import { makeStyles } from '@material-ui/core/styles'
import CheckBoxOutlineBlankIcon from 'components/material-symbol/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from 'components/material-symbol/icons/CheckBox'
import MaterialSymbol from 'components/material-symbol/material-symbol'

const CHECKBOX_ICON_SIZE = 24
const MESSAGING_CHECKBOX_BLUE = '#0053FF'

const useStyles = makeStyles({
  checkboxIcon: {
    fontFamily: '"Material Symbols Rounded Variable"',
    fontSize: CHECKBOX_ICON_SIZE,
    width: CHECKBOX_ICON_SIZE,
    height: CHECKBOX_ICON_SIZE,
    lineHeight: 1,
    overflow: 'hidden',
  },
})

const MessagingCheckbox = props => {
  const classes = useStyles()
  const iconClassName = classes.checkboxIcon

  const uncheckedIcon = (
    <CheckBoxOutlineBlankIcon
      className={iconClassName}
      fontSize={CHECKBOX_ICON_SIZE}
    />
  )
  const checkedIcon = (
    <CheckBoxIcon
      className={iconClassName}
      fill={1}
      fontSize={CHECKBOX_ICON_SIZE}
      htmlColor={MESSAGING_CHECKBOX_BLUE}
    />
  )
  const indeterminateIcon = (
    <MaterialSymbol
      className={iconClassName}
      name="indeterminate_check_box"
      fill={1}
      fontSize={CHECKBOX_ICON_SIZE}
      htmlColor={MESSAGING_CHECKBOX_BLUE}
    />
  )

  return (
    <Checkbox
      checkedIcon={checkedIcon}
      color="primary"
      icon={uncheckedIcon}
      indeterminateIcon={indeterminateIcon}
      {...props}
    />
  )
}

export default MessagingCheckbox
